<template>
  <div class="lable_item">
    <div class="lable_title">{{ label }}:</div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
  },
};
</script>

<style lang="less" scoped>
.lable_item {
  padding-top: 10px;
  .lable_title {
    margin-top: 10px;
    margin-bottom: 4px;

    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #28435B;

  }
}
/deep/ input {
  //padding: 0 20px;

  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #00819F;
}
/deep/ textarea {
  //padding: 0 20px;

  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #00819F;
}
/deep/ .van-cell {
  background: transparent;

  width: 100%;
  min-height: 42px;

  background: transparent;

  border-bottom: 1px solid #C9D2DC;

  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #AEB7C0;


}
/deep/ .van-field {
  padding-left: 0;
  padding-right: 0;
}
/deep/ .input-radio-group {
  display: flex;
  .van-radio:last-child {
    margin-right: 0;
  }
}

.gender {
  /deep/ .van-cell {
    background: none;
    border: none;
    padding: 0;
  }
  /deep/ .van-field {
    height: 100%;
  }
  /deep/ .genderBox {
    display: flex;
    width: 100%;
    .genderItem {
      width: 100%;

      height: 42px;
      background: rgba(69,161,255,0.1);
      border-radius: 21px;
      border: 1px solid #00819F;

      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #00819F;
      line-height: 22px;

      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 14px;
      box-sizing: border-box;
      &:last-child {
        margin-right: 0;
      }
    }
    .genderItem_select {
      border: none;
      background: #F8FBFF;

      color: #ffffff;
      pointer-events: none;
    }
  }
  /deep/ .genderBox_echoShow {
    pointer-events: none;
  }
}
/deep/ .right_img {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}
</style>
